import { z } from 'zod'
import { Model } from './architecture'

export const IDValidation = z.object({
  value: z.string({ required_error: '[ID] value is required' }),
})

export class ID extends Model {
  static create({ value }: z.infer<typeof IDValidation>) {
    IDValidation.parse({ value })
    return new ID(value)
  }

  static fromNumber({ value }: { value: number }) {
    return new ID(value.toString())
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
